import { MERCHANT_TERMS } from '@field-support/shared';

/**
 * Catalog copy: merchants and branches, zones and areas, branch locations and
 * the unlisted-branch review. Carried verbatim from the previous app
 * (apps/web/src/i18n/ar.ts and batch.ts); only the keys marked "new" are not.
 */
export const catalogAr = {
  catalog: {
    // New copy (UX audit #26): needs native review.
    showDeactivated: 'عرضه',
    // New copy (UX audit #11): needs native review.
    emptyBrandsFiltered: `لا يوجد ${MERCHANT_TERMS.ar.manyIndefinite} يطابقون عوامل التصفية.`,
    emptyBrandsNone: `لا يوجد ${MERCHANT_TERMS.ar.manyIndefinite} بعد.`,
    emptyBranchesFiltered: 'لا توجد فروع تطابق عوامل التصفية.',
    emptyBranchesNone: 'لا توجد فروع بعد.',
    brands: `${MERCHANT_TERMS.ar.many}`,
    branches: 'الفروع',
    brandsDescription: `${MERCHANT_TERMS.ar.many} اللي يختار منهم المندوب عند تسجيل الزيارة.`,
    branchesDescription: `فروع كل ${MERCHANT_TERMS.ar.one}، مع الموقع المؤكد ونطاق الفرع.`,
    countBrands: `${MERCHANT_TERMS.ar.one}`,
    countBrands_one: `${MERCHANT_TERMS.ar.one}`,
    countBrands_two: 'تاجرين',
    countBrands_few: `${MERCHANT_TERMS.ar.manyIndefinite}`,
    countBranches: 'فرع',
    countBranches_one: 'فرع',
    countBranches_two: 'فرعين',
    countBranches_few: 'فروع',
    searchBrands: `اسم ${MERCHANT_TERMS.ar.the} أو الكود`,
    searchBranches: 'اسم الفرع أو الكود',
    newBrand: `${MERCHANT_TERMS.ar.one} جديد`,
    newBranch: 'فرع جديد',
    branchCount: 'الفروع',
    location: 'الموقع',
    geofence: 'نطاق الفرع (م)',
    area: 'المنطقة',
    areaHint: 'الحي أو المنطقة، مثلاً مدينة نصر. تُستخدم لفلترة الفروع عند توزيع الزيارات.',
    allLocationStatuses: 'كل حالات الموقع',
    includeInactive: 'إظهار غير النشط',
    deletedHard: 'تم الحذف',
    deletedSoft: 'له سجل زيارات — تم تعطيله وإخفاؤه بدلاً من الحذف',
    // New copy (UX audit #2, #26): needs native review.
    deleteTitle: 'حذف {{name}}؟',
    deleteBrandConsequence:
      'إن لم يكن له سجل زيارات، يُحذف التاجر وفروعه نهائيًا. وإن كان له سجل زيارات، يُعطَّل ويُخفى بدلاً من الحذف لتبقى زياراته محفوظة.',
    deleteBranchConsequence:
      'إن لم يكن للفرع سجل زيارات، يُحذف نهائيًا. وإن كان له سجل زيارات، يُعطَّل ويُخفى بدلاً من الحذف لتبقى زياراته محفوظة.',
    setLocation: 'تحديد الموقع',
    clickMap: 'اضغط على الخريطة أو اكتب الإحداثيات.',
    latitude: 'خط العرض',
    longitude: 'خط الطول',
    locationsDescription: 'مواقع الفروع المؤكدة واقتراحات المواقع المسجلة أثناء الزيارات.',
    suggestionsPending: 'اقتراح موقع بانتظار المراجعة',
    suggestionsPending_one: 'اقتراح موقع بانتظار المراجعة',
    suggestionsPending_two: 'اقتراحات مواقع بانتظار المراجعة',
    suggestionsPending_few: 'اقتراحات مواقع بانتظار المراجعة',
    noSuggestions: 'لا توجد اقتراحات مواقع بانتظار المراجعة',
    suggestions: 'اقتراحات مواقع من الزيارات',
    pendingLocation: 'فروع بدون موقع',
    showOnMap: 'عرض على الخريطة',
    accuracy: 'الدقة',
    approve: 'اعتماد',
    reject: 'رفض',
    suggestedBy: 'مقترح من',
    allBrands: `كل ${MERCHANT_TERMS.ar.many}`,
    verifiedBranch: 'فرع مؤكد',
    suggestion: 'اقتراح',
  },
  geo: {
    nav: 'القطاعات والمناطق',
    // New copy (UX audit #2): needs native review.
    deleteZoneConsequence: 'سيُحذف القطاع نهائيًا. لا يُحذف إلا القطاع الفارغ: انقل مناطقه وفروعه أو احذفها أولاً.',
    deleteAreaConsequence: 'ستُحذف المنطقة نهائيًا. لا تُحذف إلا المنطقة التي ليس بها فروع.',
    title: 'القطاعات والمناطق',
    description:
      'قطاع ← منطقة ← فرع. كل فرع تابع لمنطقة واحدة؛ الفروع اللي منطقتها مش معروفة في منطقة "غير محدد" بتاعة القطاع. المقارنة بين الأسماء بتتجاهل المسافات وحالة الحروف والهمزات.',
    zone: 'القطاع',
    area: 'المنطقة',
    allZones: 'كل القطاعات',
    allAreas: 'كل المناطق',
    zones: 'القطاعات',
    areas: 'المناطق',
    newZone: 'قطاع جديد',
    newArea: 'منطقة جديدة',
    editZone: 'تعديل القطاع',
    editArea: 'تعديل المنطقة',
    nameAr: 'الاسم بالعربي',
    nameEn: 'الاسم بالإنجليزي (اختياري)',
    code: 'الكود',
    codeHint: 'حروف وأرقام ونقطة وشرطة. بيتسجل بالحروف الكبيرة.',
    managerNote: 'ملاحظة للمدير (اختياري)',
    branchCount: 'الفروع',
    areaCount: 'المناطق',
    unassigned: 'غير محدد',
    unassignedHint: 'منطقة القطاع العامة: مينفعش تتغير أو تتنقل أو تتمسح.',
    inactive: 'غير مفعّل',
    deleteRule: 'مينفعش تمسح منطقة أو قطاع فيه فروع. انقل الفروع الأول أو وقّف التفعيل.',
    moveToArea: 'نقل لمنطقة',
    moveTitle: 'نقل {{count}} فرع لمنطقة',
    moveTitle_one: 'نقل فرع واحد لمنطقة',
    moveTitle_two: 'نقل فرعين لمنطقة',
    moveTitle_few: 'نقل {{count}} فروع لمنطقة',
    moved: 'اتنقل {{count}} فرع',
    moved_one: 'اتنقل فرع واحد',
    moved_two: 'اتنقل فرعين',
    moved_few: 'اتنقلت {{count}} فروع',
    chooseArea: 'المنطقة',
    countZones: 'قطاع',
    countZones_one: 'قطاع',
    countZones_two: 'قطاعين',
    countZones_few: 'قطاعات',
    zoneOf: 'القطاع',
    selectZoneFirst: 'اختار قطاع عشان تشوف مناطقه.',
    /** New: the area's branches panel on the zones page (the previous app moved branches from the branches table only). */
    areaBranches: 'فروع المنطقة',
  },
  alerts: {
    // New copy (UX audit #11): needs native review.
    emptyFiltered: 'لا توجد إدخالات تطابق عوامل التصفية.',
    title: 'فروع كتبها المندوبون',
    description: 'أسماء فروع كتبها المندوبون لأن الفرع غير موجود في الكتالوج.',
    statusCount: 'فرع بانتظار المراجعة',
    statusCount_one: 'فرع بانتظار المراجعة',
    statusCount_two: 'فرعين بانتظار المراجعة',
    statusCount_few: 'فروع بانتظار المراجعة',
    statusNone: 'لا توجد فروع بانتظار المراجعة',
    typedName: 'الاسم المكتوب',
    verify: 'إضافة للكتالوج',
    verifyName: 'اسم الفرع المضاف',
    override: 'ربط بفرع موجود',
    chooseBranch: 'الفرع الرسمي',
    dismiss: 'تجاهل',
    zohoUpdated: 'تم تحديث تذكرة Zoho',
    zohoFailed: 'تم الحفظ. لم يتم تحديث تذكرة Zoho: {{error}}',
    zohoNotNeeded: 'تم الحفظ. ستستخدم تذكرة Zoho الفرع الصحيح عند المزامنة.',
    retryZoho: 'إعادة تحديث Zoho',
    kindFilter: 'النوع',
    kindAll: 'الفروع والاختيارات',
    kind: { BRANCH: 'الفروع', FIELD_OPTION: 'اختيارات النموذج (زي المشاريع)' },
    optionOf: 'مكتوب في «{{field}}»',
    verifyOption: 'إضافة للنموذج',
    verifyOptionName: 'الاختيار اللي هيتضاف',
    optionVerifyNotice: 'هيضيف الاختيار ده لـ«{{field}}» في مسودة النموذج. الموبايلات هتشوفه بعد نشر النموذج.',
    optionAdded: 'اتضاف لمسودة النموذج. انشر النموذج عشان يوصل للموبايلات.',
    optionAlreadyListed: 'الاختيار ده موجود في مسودة النموذج.',
    address: 'العنوان',
    agentNote: 'ملاحظة المندوب',
    location: 'موقع المندوب',
    locationSource: { REPORTED: 'وقت الإبلاغ', CHECK_OUT: 'عند الانصراف', CHECK_IN: 'عند الحضور' },
    visit: 'الزيارة',
    merchantNotListed: 'مش في القائمة: هيتضاف عند التأكيد',
    newMerchantNotice: 'المندوب كتب تاجر مش موجود في القائمة. التأكيد هيضيف التاجر ده، وبعدين الفرع تحته.',
    verifyMerchantName: 'اسم التاجر اللي هيتضاف',
    chooseMerchant: 'التاجر',
    /** New: label of the Zoho error kept on the row (the worker's text, verbatim). */
    zohoError: 'خطأ Zoho',
    zohoDetail: 'تفاصيل فنية', // new — needs native review
  },
};
